import type { SignInConfig } from '#types/config/components/form/signIn'

export default {
  brandClasses: {
    forgotPassword: 'mt-2',
    form: 'space-y-4',
    heading: 'subtitle-1',
    signUp: 'mt-6 text-sm',
    submitButton: 'mt-6 w-full',
    wrapper: 'space-y-2'
  }
} satisfies SignInConfig
